import styled from 'styled-components';

export const UpdateAvailableLabel = styled.span`
  margin-left: 10px;
  padding: 3px;
  color: #00bb99;
  border-radius: 3px;
  font-weight: 600;
  background-color: #00bb991a;
`;
